import { render, staticRenderFns } from "./ElderDetail.vue?vue&type=template&id=2351d152&scoped=true&"
import script from "./ElderDetail.vue?vue&type=script&lang=js&"
export * from "./ElderDetail.vue?vue&type=script&lang=js&"
import style0 from "./ElderDetail.vue?vue&type=style&index=0&id=2351d152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2351d152",
  null
  
)

export default component.exports